//* Library Imports
import React, { useEffect, useState } from "react";
import { message, Popover, Tag } from "antd";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import store, { RootState } from "store";
import { useSelector } from "react-redux";
import StickyHeader from "./StickyHeader";

//* Local Imports
import StickyHeaderContentWithBackButton from "modules/Common/Components/StickyHeaderContentWithBackButton";
import { ReactComponent as Ellipsis } from "assets/img/icons/ArticlePopover/Elipsis.svg";
// import Cross from "../../../assets/img/icons/cross.svg";
import Cross from "assets/img/icons/cross.svg";
import PreviewFull from "modules/Design/Shared/PreviewFull";
import ButtonSmall from "modules/Common/Components/ButtonSmall";
import { DESIGN, DESIGN_PREVIEW, GENERATE_PREVIEW } from "constants/actionTypes";

//* Functions
import { getDefaultTemplateStyleId, getPlanType } from "utils";
import { enablePublishButton } from "modules/Campaigns/Emails/actions";
import { getEditionArticles, saveSentEmailAsDraft } from "modules/Campaigns/Edition/actions";
import { resetAllData } from "modules/Campaigns/utils";
import { getQueryCampaignId, getQueryEmailId, getQueryExportPopup } from "modules/EmailBrowser/utils";
import ButtonRightIcon from "./ButtonRightIcon";
import PublishMenu from "modules/Design/Shared/PublishMenu";
import {
  checkForUnsubLink,
  checkHTMLchanges,
  getContentforSave,
  maintainHeight,
} from "modules/Design/Scripts/DynamicStripo";
import CreateAsset from "modules/Campaigns/CampaignAssets/Components/CreateAsset";
import { disablePreviewAction, enablePreviewAction, getDesignHTMLService } from "modules/Design/action";
import { ReactComponent as WarningIcon } from "../../../assets/img/icons/warningWhiteIcon.svg";
import useQuery from "../../../hooks/useQuery";
import {
  getSalesXGroupsAction,
  getSalesXGroupUsersAction,
  resetUsers,
  resetWidgetsPopupData,
} from "modules/Manage/actions";
import ExportWidgetPopUp from "modules/Manage/Shared/ExportWidgetPopUp";

interface IEditionPageHeading {
  tab?: string;
  page?: string;
  editionStatus: string;
  headingSmallGreen?: string;
  overlayClass?: string;
  headingMain?: string;
  showItem?: string;
  itemNameLoading?: boolean;
  showDesignBtn?: boolean;
  curatedCount: number;
  assetId?: number;
  campaignId?: number;
  publishLoader?: boolean;
  isEmailWithoutCampaign?: boolean;
  assetType?: string;
  editDesignAction?: any;
  prevArticlesOrder?: any;
  articlesOrder?: any;
  showPreview?: any;
  setTogglePreview?: any;
  togglePreview?: any;
  setPreviewLoader?: any;
  previewLoader?: any;
  enableStickyHeader?: boolean;
  goBackURL?: string;
  emailType?: number;
  editionArticlesLoading: boolean;
  toggleDisabled?: boolean;
  setToggleDisabled?: any;
  setPublishLoader?: (value: boolean) => void;
  setShowDesignBtn?: (value: boolean) => void;
  nameChangeHandler?: (value: any) => void;
  setRedirectToPublish?: (value: any) => void;
  setIsEmailWithoutCampaign?: (value: boolean) => void;
}

const EditionPageHeading = (props: IEditionPageHeading) => {
  const {
    tab,
    page,
    overlayClass,
    togglePreview,
    emailType,
    previewLoader,
    setPreviewLoader,
    showPreview,
    setTogglePreview,
    toggleDisabled,
    setToggleDisabled,
    headingMain,
    headingSmallGreen,
    editionStatus,
    campaignId,
    goBackURL,
    itemNameLoading,
    editionArticlesLoading,
    setIsEmailWithoutCampaign,
    isEmailWithoutCampaign,
    enableStickyHeader,
    showDesignBtn,
    setShowDesignBtn,
    // publishLoader,
    // setPublishLoader,
    setRedirectToPublish,
    showItem,
    assetId,
    assetType,
    editDesignAction,
    curatedCount,
    nameChangeHandler,
  } = props;

  const history = useHistory();

  //* local states
  const searchParams = history.location.search;
  const isSentOrError = ["Sent", "Error"].includes(editionStatus);
  // const showPublishMenu = getPlanType()?.toUpperCase() === "ENTERPRISE";
  const isDesignPage = window.location.pathname.includes("design");
  const isScheduledEmail = editionStatus === "Scheduled";
  const isCuratedTab = tab === undefined;
  const isSmartSourcedTab = tab === "source";
  const isFavoriteTab = tab === "favorites";
  const isPublishPage = tab === "publish";
  const isDigest = emailType?.toString() === "0";
  const queryCampaignId = getQueryCampaignId();
  const queryEmailId = getQueryEmailId();

  const emailTypeText =
    emailType?.toString() === "0" ? "digest" : emailType?.toString() === "1" ? "adhoc" : "loading";
  const editionStatusText = ["Draft", "Error", "Scheduled"].includes(editionStatus) ? "draft" : "sent";

  const [cloning, setCloning] = useState(false);
  const [publishLoader, setPublishLoader] = useState(false);
  const [showRedirectionMessage, setShowRedirectionMessage] = useState(false);

  const [openPublishMenuPopover, setOpenPublishMenuPopover] = useState(false);
  const setPopoverState = (value: boolean) => {
    setOpenPublishMenuPopover(value);
  };

  // hooks
  let query = useQuery();

  //* redux states
  const missingLinkError = useSelector((state: RootState) => state.design.missingLinkError);
  const disablePreview = useSelector((state: RootState) => state.design.disablePreview);
  const disablePublish = useSelector((state: RootState) => state.design.disablePublish);
  const templateId = useSelector((state: RootState) => state.design.data.template_style_id);
  const isPreviewUpdated: any = useSelector((state: RootState) => state.design.isUpdated);
  const saveDesignLoading = useSelector((state: RootState) => state.design.saveDesign.loading);
  const saveDesignSuccess = useSelector((state: RootState) => state.design.saveDesign.success);
  const saveDesignFail = useSelector((state: RootState) => state.design.saveDesign.fail);
  const htmlContent = useSelector((state: RootState) => state.design.data.html);
  const emailContent = useSelector((state: RootState) => state.design.data.email_html);
  const workflowCurrentState = useSelector((state: RootState) => state.editionData.workflowCurrentState);
  const workflowStatus: string = useSelector((state: RootState) => state.editionData.workflowStatus);
  const workflowId: number = useSelector((state: RootState) => state.editionData.workflowId);
  const previousEmailId: number = useSelector((state: RootState) => state.editionData.emailId);

  //* constants
  const isPreviewScheduledPublishLoading = previewLoader || isScheduledEmail || saveDesignLoading || publishLoader;
  const isDisabledDesignPage = disablePreview && isDesignPage;
  const isToggleDesignPage = toggleDisabled && isDesignPage;
  const isPreviewDesignSchedule = previewLoader || saveDesignLoading || isScheduledEmail;
  const isCuratedNillDigest = curatedCount <= 0 && isDigest;
  const isPrevDesignPublish = previewLoader || saveDesignLoading || publishLoader;

  const [isModalOpen, setIsModalOpen] = useState(false);

  //* Functions

  const getPreviewContent = () => {
    maintainHeight();
    // Show popup preview
    setPreviewLoader(true);

    if (isPublishPage) {
      // showPreview(true);
      enablePreviewAction();
    }
    if (!isPublishPage) {
      store.dispatch({
        type: DESIGN_PREVIEW.LOAD_SUCCESS,
        preview_html: "",
        preview_text: "",
        default_preview_text: "",
      });
    }
    if (
      (isPreviewUpdated && !isDesignPage) ||
      ((htmlContent === undefined || emailContent === undefined) && !isDesignPage)
    ) {
      getDesignHTMLService(getQueryEmailId(), getDefaultTemplateStyleId(), 0, showPreview, false, true);
      store.dispatch({
        type: GENERATE_PREVIEW.UPDATE,
        isUpdated: false,
      });
    } else {
      setPreviewLoader(false);
      setTogglePreview(true);
      disablePreviewAction();
    }
  };

  const generatePublishContent = () => {
    setPublishLoader(true);
    // Show popup preview
    store.dispatch({
      type: DESIGN_PREVIEW.LOAD_SUCCESS,
      preview_html: "",
      preview_text: "",
      default_preview_text: "",
    });
    getDesignHTMLService(getQueryEmailId(), getDefaultTemplateStyleId(), 0, redirectToPublishFunction, false);
  };

  const cloneEditionHandler = () => {
    setCloning(true);
    saveSentEmailAsDraft(queryCampaignId?.toString(), queryEmailId?.toString())
      .then((response) => {
        let data = response.data;
        if (data?.email_id) {
          setCloning(false);
          resetAllData();
          getEditionArticles(data?.email_id);
          if (data?.email_type === 1) {
            history.push(
              `/campaigns/editionedit/design?campaign_id=${getQueryCampaignId()}&email_id=${data?.email_id}`
            );
          } else {
            history.push(`/campaigns/editionedit?campaign_id=${getQueryCampaignId()}&email_id=${data?.email_id}`);
          }
        }
      })
      .catch((err: any) => {
        console.log("Clone Error: ", err);
      });
  };

  const showDesignLoaderBeforeRedirect = () => {
    store.dispatch({
      type: DESIGN.LOAD,
      loader: true,
    });
    $("#load-template").addClass("stripo-hide");
    $(".sk-container").removeClass("stripo-hide");
    $(".sk-container").removeClass("d-none");
    setToggleDisabled(true);
  };

  // warning message when
  const warningMessage = (content: string, duration?: number, marginTop?: string | number, zIndex?: number) => {
    message.warning({
      content,
      style: {
        marginTop: marginTop ? marginTop : "13vh",
        ...(zIndex ? { zIndex } : {}),
      },
      rtl: true,
      className: "warning-message-design",
      icon: <WarningIcon style={{ marginRight: "5px" }} />,
      ...(duration ? { duration } : {}),
    });
  };

  const goBackFunction = () => {
    const workflowIdFromUrl = query.get("workflow_id");
    if (query.get("from") === "workflow") {
      workflowId ? history.push(`/automation/details?workflow_id=${workflowId}`) : history.goBack();
    } else if (workflowIdFromUrl && (isDesignPage || isPublishPage)) {
      history.push(`/automation/details?workflow_id=${workflowIdFromUrl}`);
    } else {
      if (isDesignPage) showDesignLoaderBeforeRedirect();
      let url = "/campaigns/content";
      checkHTMLchanges(
        getContentforSave,
        templateId,
        url + "?campaign_id=" + getQueryCampaignId(),
        history,
        warningMessage
      );
    }
  };

  const saveAndRedirectOnClick = (path: string) => {
    showDesignLoaderBeforeRedirect();
    checkHTMLchanges(getContentforSave, templateId, path + searchParams, history, warningMessage);
  };

  const handleCuratedClick = () => {
    if (isCuratedTab) return;
    let path = "/campaigns/editionedit/";
    if (isDesignPage) {
      saveAndRedirectOnClick(path);
      return;
    }
    history.push(path + searchParams);
  };

  const handleSmartSourcedClick = () => {
    if (isSmartSourcedTab) return;
    let path = "/campaigns/editionedit/source";
    if (isDesignPage) {
      saveAndRedirectOnClick(path);
      return;
    }
    if (disablePublish) enablePublishButton();
    history.push(path + searchParams);
  };

  const handleFavoriteClick = () => {
    if (isFavoriteTab) return;
    let path = "/campaigns/editionedit/favorites";
    if (isDesignPage) {
      saveAndRedirectOnClick(path);
      return;
    }
    if (disablePublish) enablePublishButton();
    history.push(path + searchParams);
  };

  const handleClickDesign = () => {
    store.dispatch({
      type: DESIGN.RESET,
    });
    history.push("/campaigns/editionedit/design/" + searchParams);
  };

  const handleEmailPreviewClick = () => {
    getPreviewContent();
  };

  const sendAgainEditionHandler = () => {
    generatePublishContent();
  };

  const handlePublishNowClick = () => {
    if (isPublishPage) return;
    if (isDesignPage) {
      if (setRedirectToPublish) setRedirectToPublish(true);
      setPublishLoader(true);
      return;
    }
    generatePublishContent();
  };

  const redirectToPublishFunction = (
    html_content: string,
    email_content: string,
    css_content: string,
    campaign_id: number,
    email_id: number
  ) => {
    const workflowIdInURL = query.get("workflow_id");
    if (campaign_id && email_id) {
      store.dispatch({
        type: DESIGN.UPDATE_HTML,
        email_html: email_content,
        html: html_content,
        css: css_content,
      });
      if (isSentOrError) {
        setPublishLoader(false);
        history.push(
          `/campaigns/editionedit/publish/?campaign_id=${campaign_id}&email_id=${email_id}${workflowIdInURL ? `&workflow_id=${workflowIdInURL}` : ""
          }`
        );
      } else {
        let unSubLinkPresent = checkForUnsubLink(
          templateId,
          warningMessage,
          html_content,
          `/campaigns/editionedit/publish/?campaign_id=${campaign_id}&email_id=${email_id}${workflowIdInURL ? `&workflow_id=${workflowIdInURL}` : ""
          }`
        );
        // console.log("check unsub link: ", unSubLinkPresent);
        if (unSubLinkPresent) {
          setPublishLoader(false);
          history.push(
            `/campaigns/editionedit/publish/?campaign_id=${campaign_id}&email_id=${email_id}${workflowIdInURL ? `&workflow_id=${workflowIdInURL}` : ""
            }`
          );
        }
        setPublishLoader(false);
      }
    } else {
      console.error("Invalid params");
    }
  };

  //* Components

  // email preview component
  const EmailPreview = togglePreview && (
    <EmailPreviewWrapper className="designWrapper">
      <div className="preview-screen active">
        <div className="preview-label">Email Preview</div>
        <span
          className="close-preview"
          onClick={() => {
            setPreviewLoader && setPreviewLoader(false);
            setTogglePreview && setTogglePreview(false);
          }}
        >
          <img src={Cross} alt="" />
        </span>
        <PreviewFull generatePreview={true} assetType={"hybrid"} />
      </div>
    </EmailPreviewWrapper>
  );

  const CuratedButton = (
    <TagDiv>
      <Tag
        className={`${isPreviewScheduledPublishLoading || isDisabledDesignPage || isToggleDesignPage ? " disabled" : ""
          }
          ${isCuratedTab ? "styling-tag-green is-active" : "styling-tag-grey"}`}
        id="curated-tab"
        color={isCuratedTab ? "#DEF6E6" : ""}
        onClick={handleCuratedClick}
      >
        Curated <LabelSmall id="curated-count-number">{curatedCount}</LabelSmall>
      </Tag>
    </TagDiv>
  );

  const SmartSourcedButton = (
    <TagDiv>
      <Tag
        className={`${isSmartSourcedTab ? "styling-tag-green is-active" : "styling-tag-grey"}
        ${isPreviewScheduledPublishLoading || isDisabledDesignPage || isToggleDesignPage ? " disabled" : ""}
        `}
        id="smartsourced-content-tab"
        color={isSmartSourcedTab ? "#DEF6E6" : ""}
        onClick={handleSmartSourcedClick}
      >
        SmartSourced Content
      </Tag>
    </TagDiv>
  );

  const FavoriteButton = (
    <TagDiv>
      <Tag
        className={`${isFavoriteTab ? "styling-tag-green is-active" : "styling-tag-grey"} 
        ${isPreviewScheduledPublishLoading || isDisabledDesignPage || isToggleDesignPage ? " disabled" : ""}
        `}
        id="favorites-tab"
        color={isFavoriteTab ? "#DEF6E6" : ""}
        onClick={handleFavoriteClick}
      >
        Favorites
      </Tag>
    </TagDiv>
  );

  const DesignButton = (
    <TagDiv>
      {/* {isEmailWithoutCampaign ? (
        props.editDesignAction
        // <ButtonSmall
      ) : ( */}
      <Tag
        className={`design-tab style-color-green
          ${isDesignPage ? "styling-tag-green is-active " : "styling-tag-grey "}
          ${isCuratedNillDigest || isPreviewDesignSchedule || publishLoader ? "disabled" : ""}
          `}
        // isDisabled={publishLoader || isScheduledEmail || (isToggleDesignPage)}
        onClick={handleClickDesign}
      >
        Edit Design
      </Tag>
      {/* )} */}
    </TagDiv>
  );

  const EmailWithoutCampaignDesign = (
    <CreateAsset
      noDropdown={true}
      noPortal={true}
      updateAsset={true}
      assetId={queryEmailId?.toString()}
      name={props.headingMain}
      noRedirection={false}
      redirectURL={"/campaigns/editionedit/design/" + searchParams}
      callbackMethod={setIsEmailWithoutCampaign}
      className="hide-mac-article"
    >
      <TagDiv>
        <Tag
          className={isDesignPage ? "styling-tag-green" : "styling-tag-grey"}
          onClick={() => {
            store.dispatch({
              type: DESIGN.RESET,
            });
            // savetoCampaign(true, "/campaigns/editionedit/design/" + window.location.search);
          }}
        >
          Edit Design
        </Tag>
      </TagDiv>
    </CreateAsset>
  );

  const EmailPreviewButton = (
    <TagDiv>
      <Tag
        className={`preview-btn style-color-green
        ${isCuratedNillDigest || isPreviewDesignSchedule || publishLoader ? "disabled" : ""}
        styling-tag-grey `}
        // isDisabled={isPreviewScheduledPublishLoading || isToggleDesignPage ? true : false}
        onClick={handleEmailPreviewClick}
      >
        {previewLoader ? "Loading..." : "Preview"}
      </Tag>
    </TagDiv>
  );

  const PublishButton = (
    <TagDiv>
      <Tag
        className={`style-bg-green ${isDisabledDesignPage || isToggleDesignPage || isPrevDesignPublish || isCuratedNillDigest
            ? " disabled"
            : ""
          } 
        ${isPublishPage ? "styling-tag-green is-active" : "styling-tag-grey "}`}
        onClick={handlePublishNowClick}
      >
        {publishLoader ? "Loading..." : "Publish Now"}
      </Tag>
    </TagDiv>
  );

  const EmailWithoutCampaignPublish = (
    <CreateAsset
      noDropdown={true}
      noPortal={true}
      updateAsset={true}
      assetId={getQueryEmailId().toString()}
      name={props.headingMain}
      noRedirection={true}
      fromPublish={true}
      fromPublishCallBack={generatePublishContent}
      className="hide-mac-article"
    >
      <TagDiv>
        <Tag
          className={`style-bg-green ${isDisabledDesignPage || isToggleDesignPage || isPrevDesignPublish ? " disabled" : ""
            } 
        ${isPublishPage ? "styling-tag-green is-active" : "styling-tag-grey "}`}
        >
          {publishLoader ? "Loading..." : "Publish Now"}
        </Tag>
      </TagDiv>
    </CreateAsset>
  );

  const CloneEditButton = (
    <TagDiv>
      <Tag
        className={`styling-tag-grey style-color-green send-clone ${cloning || publishLoader ? "disabled" : ""}`}
        onClick={cloneEditionHandler}
      >
        {cloning ? `Loading...` : `Clone and Edit`}
      </Tag>
    </TagDiv>
  );

  const sendConstraint = () => (
    <p
      style={{
        marginBottom: 0,
        fontWeight: 400,
        fontSize: "16px",
        fontFamily: "Roboto",
        color: "rgb(15, 15, 15)",
      }}
    >
      Workflow is currently in <b>active state</b>, you cannot send it again.
    </p>
  );

  const SendAgainButton = !isPublishPage && (
    <Popover
      content={sendConstraint()}
      placement="bottomRight"
      overlayInnerStyle={{
        width: 300,
        borderRadius: 10,
      }}
      {...(workflowCurrentState !== "active" && { visible: false })}
    >
      <TagDiv>
        <Tag
          className={`styling-tag-grey style-color-green send-clone ${cloning || publishLoader || workflowCurrentState === "active" ? "disabled" : ""
            }`}
          onClick={sendAgainEditionHandler}
        >
          {publishLoader ? "Loading..." : "Send Again"}
        </Tag>
      </TagDiv>
    </Popover>
  );

  const PublishMenuButton = isPublishPage && (
    <span className="d-flex align-content-center align-items-center flex-wrap">
      <Popover
        visible={openPublishMenuPopover}
        overlayClassName={"PublishPopover "}
        placement="leftTop"
        content={<PublishMenu setPopoverState={setPopoverState} />}
        trigger="click"
        className="qa-popover-dots"
      >
        <div className="publish-menu-popover" data-qa="popover-dots-qa">
          <Ellipsis
            onClick={() => setOpenPublishMenuPopover(true)}
            className={`elipsis-style ${isScheduledEmail ? "disabled" : ""}`}
          />
        </div>
      </Popover>
    </span>
  );

  const EmptySpace = (
    <TagDiv>
      <div className="spacer-div" />
    </TagDiv>
  );

  const headerButtons: { [key: string]: any } = {
    adhoc: {
      draft: [DesignButton, EmailPreviewButton, PublishButton, PublishMenuButton],
      sent: [CloneEditButton, PublishButton, PublishMenuButton],
      // sendagain: [CloneEditButton, PublishButton, PublishMenuButton],
    },
    digest: {
      draft: [
        CuratedButton,
        SmartSourcedButton,
        FavoriteButton,
        EmptySpace,
        isEmailWithoutCampaign ? EmailWithoutCampaignDesign : DesignButton,
        EmailPreviewButton,
        isEmailWithoutCampaign ? EmailWithoutCampaignPublish : PublishButton,
        PublishMenuButton,
      ],
      sent: [
        CuratedButton,
        EmptySpace,
        SendAgainButton,
        CloneEditButton,
        isSentOrError && isPublishPage && PublishButton,
        PublishMenuButton,
      ],
      // sendagain: [CloneEditButton, PublishButton, PublishMenuButton],
    },
    // for handling while loading the page
    loading: {
      sent: [],
    },
  };

  // useEffects

  useEffect(() => {
    // if email is attached in a published workflow, we need to restrict user form editing it
    if (
      workflowCurrentState === "active" &&
      workflowStatus === "wf_graph" &&
      !isSentOrError &&
      previousEmailId !== 0 &&
      previousEmailId.toString() === queryEmailId.toString() &&
      !editionArticlesLoading &&
      !showRedirectionMessage
    ) {
      const workflowIdFromUrl = query.get("workflow_id");
      setShowRedirectionMessage(true);
      warningMessage(
        "This email is associated with published workflow, hence it cannot be edited. Redirecting back...",
        5,
        "-7vh",
        9999999
      );
      setTimeout(() => {
        if (query.get("from") === "workflow") {
          workflowId ? history.push(`/automation/details?workflow_id=${workflowId}`) : history.goBack();
        } else if (workflowIdFromUrl) {
          history.push(`/automation/details?workflow_id=${workflowIdFromUrl}`);
        } else {
          history.push(`/campaigns/content?campaign_id=${queryCampaignId?.toString()}`);
        }
      }, 5000);
    }
  }, [workflowStatus, workflowCurrentState, isSentOrError, previousEmailId, editionArticlesLoading]);

  useEffect(() => {
    if (publishLoader) setPublishLoader(false);
  }, [isPublishPage]);

  useEffect(() => {
    if (missingLinkError && publishLoader) setPublishLoader(false);
  }, [missingLinkError]);

  useEffect(() => {
    if (publishLoader) setPublishLoader(false);
  }, [saveDesignSuccess, saveDesignFail]);

  const showModal = () => {
    setIsModalOpen(true);
    let object: any = {};
    object.campaign_id = getQueryCampaignId();
    object.limit = 20;
    object.offset = 0;
    getSalesXGroupsAction(object);
    getSalesXGroupUsersAction(object);
  };
  useEffect(() => {
    const showExport = getQueryExportPopup();
    if (showExport === "true") {
      resetUsers();
      showModal();
    }
  }, []);

  /* showing a dark layer to prevent user from click anywhere on the page while loading */
  const NonEditableBackOverlay = showRedirectionMessage ? (
    <div
      style={{
        position: "fixed",
        height: "100vh",
        width: "100vw",
        top: 0,
        left: 0,
        background: "black",
        opacity: isDesignPage ? 0.2 : 0.4,
        zIndex: 12,
      }}
    />
  ) : null;

  return (
    <>
      {NonEditableBackOverlay}
      <StickyHeader {...(overlayClass ? { overlayClass: overlayClass } : {})}>
        <StickyHeaderContentWithBackButton
          firstColumnSpan={11}
          secondColumnSpan={12}
          itemName={headingMain}
          itemTitle={headingSmallGreen}
          showCircle={false}
          editionStatus={editionStatus}
          assetId={campaignId} // assetId is campaignId
          nonEditable={!headingMain || isSentOrError}
          page={page}
          {...(nameChangeHandler ? { editNameSubmitHandler: nameChangeHandler } : {})}
          loading={itemNameLoading || editionArticlesLoading}
          goBackURL={goBackURL}
          {...(isDesignPage ? { goBackFunction: goBackFunction } : {})}
        >
          <StickyHeaderContentContainer>
            {headerButtons[emailTypeText][editionStatusText]}
          </StickyHeaderContentContainer>
        </StickyHeaderContentWithBackButton>
      </StickyHeader>
      {/* show email preview down here */}
      {EmailPreview}

      {isModalOpen && (
        <ExportWidgetPopUp
          title="Export to Sales X"
          subtitle="TM"
          onClose={() => {
            resetWidgetsPopupData();
            setIsModalOpen(false);
          }}
        />
      )}
    </>
  );
};

export default EditionPageHeading;

const EmailPreviewWrapper = styled.div`
  &.designWrapper {
    // display: flex;
    // flex-wrap: wrap;
    .preview-screen {
      height: 100vh;
      background-color: #f9f8f6;
      z-index: -999;
      display: none;
      padding-right: 15px;
      transition: 0.5s;
      position: fixed;
      top: 0;
      left: 88px;
      width: calc(100% - 88px);
      padding-top: 25px;
      border-right: 1px solid #b5c3d4;
      overflow: auto;
      box-sizing: border-box;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: calc(100% - 63px);
        left: 63px;
      }
      &.active {
        z-index: 99;
        display: block;
      }
      .ant-tabs-nav {
        .ant-tabs-nav-list {
          transform: translate(-50%, 0px) !important;
          left: 50% !important;
          .ant-tabs-tab {
            margin-left: 0px;
            border-radius: 8px 0 0 8px;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              border-radius: 6px 0 0 6px;
            }
            + .ant-tabs-tab {
              margin-left: 0px;
              border-radius: 0 8px 8px 0;
              @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
                border-radius: 0 6px 6px 0;
              }
            }
          }
        }
      }
      .preview-label {
        position: absolute;
        top: 20px;
        left: 25px;
        color: #424b50;
        font-family: "Roboto Slab", serif;
        font-weight: 500;
        font-size: 32px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 24px;
          top: 25px;
        }
      }
      .close-preview {
        position: absolute;
        top: 30px;
        right: 20px;
        z-index: 9;
        cursor: pointer;
      }
    }
  }
`;

const StickyHeaderContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: end;
  .elipsis-style {
    /* margin-left: 10px; */
    width: 20px;
    height: 27px;
    &:hover {
      cursor: pointer;
    }
  }
  .disabled {
    pointer-events: none;
    opacity: 0.7;
  }
  .is-active {
    pointer-events: none;
  }
  button,
  .styling-tag-grey {
    word-break: break-all;
    white-space: nowrap;
  }
  .publish-btn {
    min-width: 148px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      min-width: 148px;
    }
    button {
      min-width: 130px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        min-width: 130px;
      }
    }
    .publish-menu-popover {
      min-width: 15px;
    }
  }
`;

const TagDiv = styled.div`
  .styling-tag-green {
    border: 1px solid #dadada;
    font-size: 16px;
    font-family: "robotoregular";
    font-weight: 700;
    border-radius: 8px;
    vertical-align: middle;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: left;
    color: #09a43a;
    cursor: pointer;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
      border-radius: 6px;
      padding: 6px 12px;
    }
  }
  .styling-tag-grey {
    border: 1px solid #dadada;
    font-size: 16px;
    font-family: "robotoregular";
    font-weight: 700;
    border-radius: 8px;
    vertical-align: middle;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: left;
    color: #7e7e7e;
    cursor: pointer;
    background-color: #fff;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
      border-radius: 6px;
      padding: 6px 12px;
    }
  }
  .style-color-green {
    color: rgb(39, 206, 10);
    border: 1px solid rgb(39, 206, 10);
  }

  .style-bg-green {
    background: rgb(39, 206, 10);
    color: #fff;
    border: 1px solid rgb(39, 206, 10);
  }

  .spacer-div {
    width: 44px;
    height: 100%;
  }

  .send-clone:hover {
    background: rgb(39, 206, 10);
    color: white;
  }
`;

const LabelSmall = styled.div`
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  font-family: "robotoregular";
  background: #27ce0a;
  border-radius: 12px;
  padding: 2px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -2px 0 -2px 5px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    font-size: 10px;
    border-radius: 10px;
    padding: 0px 8px;
  }
`;
